import { useEffect } from "react";
import { Form, Select } from "antd";
import { type FormInstance } from "antd/lib/form";
import { useTranslation } from "react-i18next";

import { useTagOptions } from "~/hooks/useTagOptions";

export interface SalesRepTagsFormModel {
  tags: string[];
}

interface SalesRepTagsFormProps {
  formController?: FormInstance<SalesRepTagsFormModel>;
  onSubmit: (formData: SalesRepTagsFormModel) => void;
  model?: SalesRepTagsFormModel | null;
}

// TRE-1636: sales reps edit tags only — the full profile form stays trainer-only.
export const SalesRepTagsForm = ({ formController, onSubmit, model }: SalesRepTagsFormProps) => {
  const { t } = useTranslation(["trainees"]);
  const { options: tagsOptions } = useTagOptions("traineeTags");
  // ModalForm injects a controller, but fall back to a local instance so the
  // form still initializes from `model` if the component is ever used standalone.
  const [internalForm] = Form.useForm<SalesRepTagsFormModel>();
  const form = formController ?? internalForm;

  useEffect(() => {
    form.setFieldsValue({ tags: model?.tags ?? [] });
  }, [form, model]);

  return (
    <Form<SalesRepTagsFormModel>
      name="form"
      layout="vertical"
      form={form}
      initialValues={{ tags: [] }}
      onFinish={onSubmit}
    >
      <Form.Item name="tags" label={t<string>("profileForm.tags")}>
        <Select allowClear notFoundContent={false} options={tagsOptions} mode="tags" />
      </Form.Item>
    </Form>
  );
};
